import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Snooze } from "models";

export const useAppendQuestionResultSnoozeMutation = () =>
  useTypedMutation<Snooze, number>({
    mutationFn: async payload => (await ApiInstance.post("/snoozes/append", payload)).data.id,
    onSuccess: (payload, id) => {
      const checks = typedQueryClient.getQueryData(AppointmentDetailsKeys.checks);
      if (!checks?.length) return;

      const checkIdx = checks.findIndex(c => c.question_items?.some(q => q.id === payload.question_result_id));
      if (checkIdx === -1 || !checks[checkIdx].question_items?.length) return;

      const questionResultIdx = checks[checkIdx].question_items.findIndex(q => q.id === payload.question_result_id);
      if (questionResultIdx === -1) return;

      const question = checks[checkIdx].question_items[questionResultIdx];
      let snoozeHistory = [...(question.snooze_history ?? [])];
      const snoozeIdx = snoozeHistory.findIndex(s => s.id === id);
      snoozeHistory = snoozeIdx === -1 ? [{ ...payload, id }, ...snoozeHistory] : snoozeHistory.with(snoozeIdx, { ...snoozeHistory[snoozeIdx], ...payload, id });

      typedQueryClient.setQueryData(
        AppointmentDetailsKeys.checks,
        checks.with(checkIdx, {
          ...checks[checkIdx],
          question_items: checks[checkIdx].question_items.with(questionResultIdx, { ...question, snoozed: true, snooze_history: snoozeHistory })
        })
      );
    }
  });
